var productSlider;

(function ($) {
	$.fn.serializeArrayAll = function () {
		var rCRLF = /\r?\n/g;
		return this.map(function () {
			return this.elements ? jQuery.makeArray(this.elements) : this;
		})
			.map(function (i, elem) {
				var val = jQuery(this).val();
				if (val == null) {
					return val == null;
					//next 2 lines of code look if it is a checkbox and set the value to blank
					//if it is unchecked
				} else if (this.type == "checkbox" && this.checked === false) {
					return { name: this.name, value: this.checked ? this.value : "" };
					//next lines are kept from default jQuery implementation and
					//default to all checkboxes = on
				} else if (this.type === "radio") {
					if (this.checked) {
						return { name: this.name, value: this.checked ? this.value : "" };
					}
				} else {
					return jQuery.isArray(val)
						? jQuery.map(val, function (val, i) {
								return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
						  })
						: { name: elem.name, value: val.replace(rCRLF, "\r\n") };
				}
			})
			.get();
	};

	$(document).ready(function () {
		$(".opcion").click(function (event) {
			event.preventDefault();
			$(".opcion").removeClass("active");
			$(this).addClass("active");

			if ($(this).hasClass("si")) {
				$(".opcion-personalizar").addClass("show");
			} else {
				$(".opcion-personalizar").removeClass("show");
			}
		});

		$(".formato").click(function (event) {
			event.preventDefault();
			$(".formato").removeClass("active");
			$(this).addClass("active");
		});

		$(".accordion-button").on("click", function () {
			if ($(this).hasClass("collapsed")) {
				$(this).find(".ico-plus").show();
				$(this).find(".ico-minus").hide();
			} else {
				$(this).find(".ico-plus").hide();
				$(this).find(".ico-minus").show();
			}
		});

		if (jQuery("#expandir").length) {
			document
				.getElementById("expandir")
				.addEventListener("click", function (event) {
					event.preventDefault();
					const contenedor = document.getElementById("contenedor");
					contenedor.classList.toggle("expandido");
					document.querySelector(".contenedor .gradient").style.display = "none";

					const buttonExpandir = document.getElementById("expandir");
					buttonExpandir.style.display = "none";
					const contenedor2 = document.getElementById("fondo");
					contenedor2.style.display = "none";
				});
		}

		jQuery("form.cart .search-button").on("click", function (e) {
			e.preventDefault();
		});	
		
		if ($(".botones_sticky").length > 0) {
			$(window).on("scroll", function () {
				evento_on_scroll_botones_sticky();
			});
			function evento_on_scroll_botones_sticky() {
				let posicion_vertical_viewport = $(window).scrollTop() + $(window).height();
				let posicion_original_botones = $(".botones_sticky").siblings(".stickyButtonsFirstPosition").first().offset().top;
				let posicion_personalizar_box = $(".personalizar").first().offset().top + $(".personalizar").first().outerHeight();

				if ( posicion_vertical_viewport > posicion_personalizar_box + 131 && posicion_vertical_viewport < posicion_original_botones + $(".botones_sticky").outerHeight()) {
					$(".botones_sticky").addClass("sticky_active");
				} else {
					$(".botones_sticky").removeClass("sticky_active");
				}
			}
			evento_on_scroll_botones_sticky();
		}
	});

	$(document).on("input change", "#customily-options input[type=text]", function(){
		let val = $(this).val();
		$(this).css("border-color","");
		$(this).siblings(".tg-error").remove();
		
		if(hasEmoji(val)){
			$(this).css("border-color","red");
			$(this).after('<span class="tg-error">*Elimina los emojis antes de añadir al carrito</span>');
		}
	});

	$(document).on(
		"click",
		".single_add_to_cart_button:not(.disabled)",
		async function (e) {
			e.preventDefault();
			let error = false;
			$(".tg-error").remove();

			jQuery("#customily-options input[type=text]").each((i,e) => {
				let val = $(e).val();
				$(e).css("border-color","");
				if(hasEmoji(val)){
					$(e).css("border-color","red");
					$(e).after('<span class="tg-error">*Elimina los emojis antes de añadir al carrito</span>');
					error = true;
				}
			});

			if(error) return jQuery("#customily-options")[0].scrollIntoView();

			$thisbutton = $(this);

			const $form = $thisbutton.closest("form.cart");
			appendSymbolsIntoForm($form);
			
			var newFormData = new FormData($form[0]);

			var product_id = $form.find("input[name=variation_id]").val() || $thisbutton.val();

			newFormData.append('product_id', product_id);
			newFormData.append('action', 'custom_add_to_cart');

			$(document.body).trigger("adding_to_cart", [$thisbutton, newFormData]);

			if($thisbutton.siblings(".single_add_to_cart_button").length){
				$thisbutton.siblings(".single_add_to_cart_button").prop("disabled", true);
				$thisbutton.siblings(".single_add_to_cart_button").addClass("loading");
				$thisbutton.prop("disabled", true);
			}else{
				$thisbutton.prop("disabled", true);
				$thisbutton.removeClass("added").addClass("loading");
			}
				
			if(typeof engraver != "undefined"){
				await engraver.waitFilesUpload();
			}

			$( document.body ).trigger( 'adding_to_cart', [ $thisbutton, newFormData ] );

			$.ajax({
				type: "POST",
				url: woocommerce_params.wc_ajax_url
					.toString()
					.replace("%%endpoint%%", "add_to_cart"),
				data: newFormData,
				processData: false,
  				contentType: false,
				success: async function (response) {

					if (response.error && response.product_url) {
						window.location = response.product_url;
						return;
					}

					$(document.body).trigger("added_to_cart", [
						response.fragments,
						response.cart_hash,
						$thisbutton,
					]);
					
					$(".sidecart-advice").css("display", "flex");

				},
				complete: function() {

					if($thisbutton.siblings(".single_add_to_cart_button").length){
						$thisbutton.siblings(".single_add_to_cart_button").prop("disabled", false);
						$thisbutton.siblings(".single_add_to_cart_button").removeClass("loading");
						$thisbutton.prop("disabled", false);
					}else{
						$thisbutton.prop("disabled", false);
						$thisbutton.addClass("added").removeClass("loading");
					}

				},
			});
			return false;
		}
	);
})(jQuery);

const sliderThumbnail = new Swiper(".product-thumbnail-slider", {
	slidesPerView: 6,
	freeMode: true,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
	spaceBetween: 10,
});

productSlider = new Swiper(".product-slider", {
	spaceBetween: 10,
	simulateTouch: false,
	allowTouchMove: false,
	thumbs: {
		swiper: sliderThumbnail,
		slidesPerView: 6,
	},
});

window.addEventListener("customily-live-preview-shown", function(){
	jQuery(".product-slider picture").removeClass("hidden");
});

window.addEventListener("customily-product-loaded", function(){
	let newThumbnailUrl = themeVars.templateUrl + "/assets/img/midisenio.webp";
	let options = window?.customilyWordpress?.unifiedSettings?.sets[0]?.options ?? [];

	addNewSlideAtBeginning(newThumbnailUrl);
	jQuery(".product-slider picture").removeClass("hidden");
	jQuery("#customily-options").on("click", function(){
		productSlider.slideTo(0);
	});

	engraver.canvas.getObjects().forEach((e)=>{
		if( [999, 998].includes(e.id) ) e.starMapConfig = true;
	});

	options.forEach((option) => {
		if( option.hasOwnProperty('button_class') && option.button_class.indexOf('blockMovement') !== -1 && option.hasOwnProperty("file_upload_vector_id") ){
			let element = engraver.canvas.getObjects().find(el => el.id == option.file_upload_vector_id);
			
			if(element && element.hasOwnProperty("starMapConfig")) element.starMapConfig = true;
			if(element && element.hasOwnProperty("_controlRectangle")) element._controlRectangle.visible = false;
		}
	})
	
	engraver.refreshControlsVisibility();
});

window.addEventListener("customily-live-preview-shown", function(){
	let isMoved = document.querySelector(".canvas-moved");
	let isCanvasOnFirstSlider = document.querySelector(".first-slider .cl-canvas-container");

    if(isMoved && !isCanvasOnFirstSlider){
		let canvasContainer = document.querySelector(".cl-canvas-container");
		let firstSlider = document.querySelector(".first-slider");
		firstSlider.appendChild(canvasContainer);
	}
});

function addNewSlideAtBeginning(newThumbnailUrl) {
	let mainContent = document.querySelector(".cl-canvas-container");
	let isMoved = document.querySelector(".canvas-moved");

	if (mainContent && !isMoved) {
		let newSlide = document.createElement("div");
		newSlide.classList.add("swiper-slide");
		newSlide.classList.add("first-slider");

		newSlide.appendChild(mainContent);
		mainContent.style.display = "block";
		mainContent.style.maxWidth = "100%";

		productSlider.prependSlide(newSlide);

		let newThumbnailSlide = document.createElement("div");
		newThumbnailSlide.classList.add("swiper-slide");

		let newThumbnail = document.createElement("img");
		newThumbnail.setAttribute("src", newThumbnailUrl);
		newThumbnail.setAttribute("alt", "New Thumbnail");
		newThumbnail.classList.add("img-fluid");

		newThumbnailSlide.appendChild(newThumbnail);

		sliderThumbnail.prependSlide(newThumbnailSlide);

		jQuery("body").addClass("canvas-moved");

		jQuery(".cl-canvas-container").addClass("shown");
		
		productSlider.slideTo(0);
	}
}

function hasEmoji(text) {
	const regexEmoji = /\p{Extended_Pictographic}/u;
	return regexEmoji.test(text);
}

function appendSymbolsIntoForm($form)
{
	let originalInputs = $form.find('input[type="text"]').not('.customily-hidden-property, [name="properties[_customily_item_uuid]"]');

	if(originalInputs.length){
		$.each(originalInputs, function(index, inputEl){
			let inputName = $(inputEl).attr("name");
			let $hiddenInputClone = $form.find(`input[type="text"][name="${inputName}"].customily-hidden-property`);
			let valueFormatted = escapeHTML( $(inputEl).val() );
	
			$hiddenInputClone.val(valueFormatted);
		});
	}
	
}

function escapeHTML(text) {
	if(!text) return;

	return text
	  .replace(/&/g, "&amp;")
	  .replace(/</g, "&lt;")
	  .replace(/>/g, "&gt;")
	  .replace(/"/g, "&quot;")
	  .replace(/'/g, "&#39;");
}
